// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__U-PDI","buttons":"PendingPaymentAlert_buttons__94VEu"};